function Card({ type, src, alt, subheading, title, description }) {
    if (type === 'image') {
    return (
        <div>
        <img src={src} alt={alt} style={{ width: '100%', height: 'auto' }} />
        </div>
    );
    } else if (type === 'smallerImage') {
    return (
        <div style={{ display: 'flex', justifyContent: 'center', padding: '1rem 0' }}>
        <img src={src} alt={alt} />
        </div>
    );
    } else if (type === 'text') {
    return (
        <div>
        <h2>{title}</h2>
        <h4>{subheading}</h4>
        <p>{description}</p>
        </div>
    );
    } else {
    return null; // just in case no type is provided
    }
}

export default Card;